import React from 'react';
import PropTypes from 'prop-types';

/** Form Header, mainly the title */
export default function FormSubtitle({ title, titleClass }) {
  return (
    <div className="form-group m-form__group row">
      <div className="col-12 ml-auto">
        <h4 className={`m-form__section ${titleClass}`}>{title}</h4>
      </div>
    </div>
  );
}

FormSubtitle.propTypes = {
  /** Title to display */
  title: PropTypes.string.isRequired,
  titleClass: PropTypes.string,
};

FormSubtitle.defaultProps = {
  titleClass: '',
};
